import React from 'react'
import {
  Route,
  IndexRoute,
} from 'react-router'

/** Route pages */
import Populator from 'populators/Product'

const Product = (store) => {
  const Routes = () => (
    <Route path="products" component={Populator.components.Home} name="Service">
      <IndexRoute
        component={Populator.components.List}
        onEnter={() => Populator.populate.list(store)}
        name="List"
      />
      <Route
        path=":id"
        component={Populator.components.Home}
        name="Detail"
      >
        <IndexRoute
          component={Populator.components.Detail}
          onEnter={next => Populator.populate.detail(store, next.params.id)}
          name="Detail"
        />
        <Route
          path="portfolio/:portfolioId"
          component={Populator.components.Portfolio}
          onEnter={next => Populator.populate.portfolio(
            store,
            next.params.portfolioId,
            next.params.id)}
          name="Sample"
        />
      </Route>
    </Route>
  )

  return Routes()
}

export default Product
